import { Box, Button, Flex, Text, Tabs } from "@mantine/core";
import AddButton from "../../../components/AddButton";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import { useSelector } from "react-redux";
import { getAllStaffSkypoint } from "../../../services/staff";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import useStyles from "./style";
import { ReportIconSvg } from "../../../components/Svgs/ReportIconSvg";
import SkypointProjectTable from "../../../components/SkypointProjectTable";
import NewTaskModal from "../../../components/ProjectModal/index";
import KanbanBoard from "../../../components/Projectboard";
import { getSkypointProjectTaskStatus } from "../../../services/skypointProject";
import { isStaff } from "../../../http";

const Project = () => {
  const { profile } = useSelector((state) => state.profile);

  const [selectedTab, setSelectedTab] = useState("backlog");

  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);

  useEffect(() => {
    getAllStaffSkypoint("all");
    getSkypointProjectTaskStatus();
  }, []);

  return (
    <Box className={classes.content}>
      <AppNavbar title={"Project"} profile={profile} />

      <NewTaskModal
        opened={opened}
        onClose={close}
        mode="add"
        selectedTask={null}
      />
      <Box px={20}>
        {/* ============================
                TABS + NEW TASK BUTTON
        ============================ */}
        <Flex
          align="center"
          justify="space-between"
          bg="white"
          className={classes.btn}
          pr={10}
        >
          {/* LEFT: TABS */}
          <Tabs
            value={selectedTab}
            onTabChange={setSelectedTab}
            defaultValue="backlog"
            keepMounted={false}
            className={classes.tabs}
          >
            <Tabs.List>
              <Tabs.Tab value="backlog">Backlog</Tabs.Tab>

              <Tabs.Tab value="board">Board</Tabs.Tab>

              {/* <Tabs.Tab value="settings">Settings</Tabs.Tab> */}
            </Tabs.List>
          </Tabs>

          {/* RIGHT: ADD BUTTON */}
          {!isStaff(profile?.user?.role) && (
            <AddButton title={"+ New Task"} onClick={open} />
          )}
        </Flex>

        {/* ============================
                BACKLOG CONTENT
        ============================ */}
        {selectedTab === "backlog" && <SkypointProjectTable />}

        {/* ============================
                BOARD CONTENT
        ============================ */}
        {selectedTab === "board" && <KanbanBoard />}

        {/* ============================
                SETTINGS CONTENT
        ============================ */}
        {selectedTab === "settings" && (
          <Box mt={20}>
            <Text fz={18} fw={600}>
              Settings Panel
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Project;
